// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"094bc767","488":"6abe9afd"}[chunkId] + ".chunk.js";
};